<ng-template #middleOfficeButton>
  @if (isMiddleOfficeAvailable()) {
    <app-button-middle-office type="EDIT_TEAMS" />
  }
</ng-template>

@if (teams().length > 0) {
  <section class="mask-curve-top bg-gray-light pb-[30px] pt-[52px]">
    <div class="centered-with-padding">
      <div class="grid grid-cols-[auto_1fr] items-center">
        <div class="pr-2.5">
          <ng-container *ngTemplateOutlet="middleOfficeButton" />
        </div>
        <app-title [title]="data.title" size="h2" />
      </div>
      <div class="max-w-[calc(100vw-40px)] desk:max-w-[calc(100vw-max(100vw-1080px,0px))]">
        <div
          #slidesElementRef
          [class.desk:gap-x-14]="teams().length <= 4"
          [class.desk:justify-center]="teams().length <= 4"
          [class.desk:grid-rows-1]="teams().length <= 6"
          class="no-scrollbar mb-4 mt-6 grid snap-x snap-mandatory grid-flow-col grid-rows-2 items-center gap-y-[9px] overflow-x-scroll scroll-smooth text-center">
          @for (team of teams(); track $index) {
            <!-- Full size grid cell -->
            <div
              [ngClass]="{ 'snap-start': $index % kitchenersPerSlide() === 0 }"
              class="mx-auto w-[calc(100vw/2-20px)] desk:w-[calc(calc(100vw-max(100vw-1080px,0px))/6)]">
              <div class="flex h-[213px] items-center justify-center">
                <!-- Slot + sticker -->
                <div class="relative h-[185px] w-[154.5px] rounded-[25px] border border-black/40">
                  <div
                    [ngClass]="[getStickerTransform($index)]"
                    class="absolute left-[2%] top-[2%] z-10 size-[96%] overflow-hidden rounded-[25px]">
                    <app-image
                      [image]="team.image"
                      [isPriority]="!isImageInPreviousBlocks && $index === 0"
                      [pregenerationSize]="{ width: 146, height: 176 }" />
                  </div>
                </div>
              </div>
              <!-- Legend -->
              <div class="-mt-2 flex flex-col items-center">
                <span class="font-title text-[25px] leading-[34px] tracking-[-0.7px]">{{
                  team.name | capitalizeName
                }}</span>
                <span class="font-[500] leading-[19px]">{{ team.position }}</span>
              </div>
            </div>
          }
        </div>
        <!-- Controls -->
        @if (nSlides() > 1) {
          <div class="mx-auto mt-[17px] flex w-fit gap-[9px]">
            @for (i of nSlides() | generateRange; track i) {
              <div
                (click)="setCurrentSlide(i)"
                [ngClass]="{
                  'border-black/20': currentSlide() !== i,
                  'border-black': currentSlide() === i,
                  'bg-black': currentSlide() === i,
                }"
                class="size-5 cursor-pointer rounded-[5px] border border-black/20"></div>
            }
          </div>
        }
      </div>
    </div>
  </section>
} @else if (isMiddleOfficeAvailable()) {
  <div class="centered-with-padding py-7">
    <div class="grid grid-cols-[auto_1fr] items-center">
      <div class="pr-2.5">
        <ng-container *ngTemplateOutlet="middleOfficeButton" />
      </div>
      <app-title [title]="data.title" size="h2" />
    </div>
  </div>
}
